
















import KendoDatePicker from '@/components/kendo-datepicker/kendo-datepicker.vue';
  import moment from 'moment';
  import {i18nMixin} from '@/modules/neodash/mixins';
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import {MonthYear, Period, PeriodFormValue} from '@/modules/neodash/model/types/interfaces/Period';
  import MonthYearForm from '@/modules/neodash/components/filter-form/month-year-form/month-year-form.vue';

  @Component({
    name: 'FormPeriod',
    components: {
      MonthYearForm,
      KendoDatePicker,
    }
  })
  export default class PeriodForm extends Vue {
    public readonly translate = i18nMixin.methods.i18n;

    public initDate: MonthYear = {year: new Date().getFullYear(), month: 1};
    public finalDate: MonthYear = {year: new Date().getFullYear(), month: new Date().getMonth()};

    @Prop({required: false})
    initialValue: Period;

    @Prop({required: true})
    limits: Period;

    public created() : void {
      if (this.initialValue) {
        const {initial, final} = this.initialValue;
        this.initDate = initial;
        this.finalDate = final;

        return;
      }

      if (!this.limits)
        return;

      this.initDate = this.limits.final;
      this.finalDate = this.limits.final;
    }

    public get initialLimits(): Period {
      const {initial, final} = this.limits;

      if (!initial || !final)
        return {} as Period;

      return {initial, final};
    }

    public get finalLimits(): Period {
      const {initDate} = this;

      if (!this.limits.final)
        return {} as Period;

      return {
        initial: initDate,
        final: this.limits.final
      }
    }

    public emitNewValue() {
      const {initDate, finalDate} = this;

      const label = [initDate, finalDate]
          .map(x => moment(new Date(x.year, x.month - 1)).format('MMM YYYY'))
          .join(' - ');

      const newValue: PeriodFormValue = {
        label,
        value: {
          dtYearInit: initDate.year,
          dtMonthInit: initDate.month,
          dtYearFinal: finalDate.year,
          dtMonthFinal: finalDate.month
        }
      };
      this.$emit('input', newValue);
      this.$emit('change', newValue);
    }
  }
